module.exports = __webpack_public_path__ + "static/media/signage-industrial-img12.6ed39504.jpg";